import type { IEventMap } from '@/common';
import * as utils from '@reolink-web/utils';
class Event extends utils.Class.EventEmitter<IEventMap> {}

const eventBus = new Event();

export default eventBus;
